<template>
    <div class="about">

        <v-row>
            <v-col class="py-6">
                <div class="content">
                    <v-row>
                        <v-col cols="12" md="6" class="about-text">
                            <h4>{{page.about_blocks.data[0].attributes.title}}</h4>
                            <p>
                                {{page.about_blocks.data[0].attributes.content}}
                                <br><br>
                                {{page.about_blocks.data[0].attributes.content2}}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="about-image">
                            <img src="@/assets/media/Group-221.svg">
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <div class="content">
                    <v-row>
                        <v-col class="d-flex justify-center">
                            <h3>Our services</h3>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <v-row class="about-grey">
            <v-col class="py-6">
                <div class="content">
                    <v-row>
                        <v-col class="about-image">
                            <img src="@/assets/media/Group-222.svg">
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="6" class="about-text">
                            <h4>{{page.about_blocks.data[1].attributes.title}}</h4>
                            <p>
                                {{page.about_blocks.data[1].attributes.content}}
                                <br><br>
                                {{page.about_blocks.data[1].attributes.content2}}
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-6">
                <div class="content">
                    <v-row>
                        <v-col cols="12" md="6" class="about-text">
                            <h4>{{page.about_blocks.data[2].attributes.title}}</h4>
                            <p>
                                {{page.about_blocks.data[2].attributes.content}}
                                <br><br>
                                {{page.about_blocks.data[2].attributes.content2}}
                            </p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="about-image">
                            <img src="@/assets/media/Group-223.svg">
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <v-row class="about-grey">
            <v-col class="py-6">
                <div class="content">
                    <v-row>
                        <v-col class="about-image">
                            <img src="@/assets/media/Group-224.svg">
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="6" class="about-text">
                            <h4>{{page.about_blocks.data[3].attributes.title}}</h4>
                            <p>
                                {{page.about_blocks.data[3].attributes.content}}
                                <br><br>
                                {{page.about_blocks.data[3].attributes.content2}}
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import SiteService from "../services/site.service";

    export default {
        name: 'About',
        data() {
            return {
                page: {}
            }
        },
        async beforeMount() {
            this.page = await SiteService.getAboutPage();
        }
    }
</script>

<style scoped>

    .about-grey {
        background: #F4F5F6;
    }

    .about h4 {
        font-size: 26px !important;
        font-weight: 700 !important;
        margin-bottom: 10px;
    }

    .about h3 {
        font-size: 30px !important;
        font-weight: 700 !important;
        margin-bottom: 30px;
    }

    .about p {
        font-size: 16px !important;
        font-weight: 400 !important;
    }

    .about ul {
        list-style: none;
        padding: 0;
        margin: 21px 0 0 0;
    }

    .about ul li {
        margin: 0 0 25px 0;
        padding: 0;
        font-size: 20px;
        font-weight: 700;
    }

    .about .content {
        width: 90%;
    }

    .about-image {
        justify-content: center;
        display: flex;
        padding-top: 20px;
        padding-bottom: 50px;
    }

    .about-text {
        padding-top: 0;
    }

    .about .spacer {
        display: none;
    }
    .about-grey .about-image {
        order: 2;
    }
    .about-grey .about-text {
        order: 0;
    }

    .about-image img {
        max-width: 70%;
    }

    @media (min-width: 1240px) {

        .about-image img {

            max-width: unset !important;
        }

    }

    @media (min-width: 960px) {

        .about .content {
            /*padding-left: 5%;*/
            /*padding-right: 5%;*/
        }

        .about-image {
            padding-top: 50px;
            padding-bottom: 50px;
            justify-content: flex-end;
        }

        .about-grey .about-image {
            justify-content: flex-start;
        }

        .about-text {
            padding-top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .about-grey .about-image {
            order: 0;
        }

    }

    @media (min-width: 1240px) {

        .about .content {
            /*padding-left: 20px;*/
            /*padding-right: 20px;*/
        }

    }

    @media (min-width: 1280px) {

        .about .content {
            /*padding-left: 0;*/
            /*padding-right: 0;*/
        }

    }

</style>
